import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Trans } from '@lingui/macro';
import { useDataStore } from '../../data-table/DataStore';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        gap: theme.spacing(6),
        padding: theme.spacing(0, 0),
        alignItems: 'center',
    },
    label: {
        fontSize: '0.875rem',
        fontWeight: 'bold',
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap',
    },
}));

/**
 * Displays polling status summary counts for monitored interfaces.
 * Shows Auto-Enabled, Auto-Disabled, User-Enabled, and User-Disabled counts.
 * Automatically updates when table data changes (e.g., filter applied).
 */
export default function PollingStatusSummary() {
    const classes = useStyles();
    const { countOfOn, countOfOff, countOfEnabled, countOfDisabled, hasLoaded } = useDataStore();

    // Don't render until data has loaded
    if (!hasLoaded) {
        return null;
    }

    // Handle missing or invalid count values
    const formatCount = (count) => {
        return typeof count === 'number' && count >= 0 ? count : 0;
    };

    return (
        <Box className={classes.root}>
            <Typography className={classes.label}>
                <Trans>Auto-Enabled</Trans> : {formatCount(countOfOn)}
            </Typography>
            <Typography className={classes.label}>
                <Trans>Auto-Disabled</Trans> : {formatCount(countOfOff)}
            </Typography>
            <Typography className={classes.label}>
                <Trans>User-Enabled</Trans> : {formatCount(countOfEnabled)}
            </Typography>
            <Typography className={classes.label}>
                <Trans>User-Disabled</Trans> : {formatCount(countOfDisabled)}
            </Typography>
        </Box>
    );
}
